import { syncDirtyBudgets } from "containers/Budget/_actions";
import { push } from "connected-react-router";
import ReactGA from "react-ga4";

const actionTypes = {
    FERTILISER_SUBMIT: "FERTILISER_SUBMIT",
    FERTILISER_DELETE: "FERTILISER_DELETE",
    DCD_SUBMIT: "DCD_SUBMIT",
    DCD_DELETE: "DCD_DELETE",
};

export default actionTypes;

export function submitFertiliser(farmId, budgetId, fertiliser) {
    ReactGA.event({
        category: "Fertiliser",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.FERTILISER_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, fertiliser: fertiliser } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteFertiliser(farmId, budgetId, fertiliser, redirect = false) {
    ReactGA.event({
        category: "Fertiliser",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.FERTILISER_DELETE, payload: { farmId: farmId, budgetId: budgetId, fertiliser: fertiliser } });
        dispatch(syncDirtyBudgets(budgetId));
        redirect && dispatch(push(`/app/farm/${farmId}/analysis/${budgetId}/fertiliser`));
    };
}

export function saveDCD(farmId, budgetId, nitrateInhibitors) {
    ReactGA.event({
        category: "DCD",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.DCD_SUBMIT, payload: { farmId, budgetId, nitrateInhibitors } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteDCD(farmId, budgetId) {
    ReactGA.event({
        category: "DCD",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.DCD_DELETE, payload: { farmId, budgetId } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}
